import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    rawMaterials: [],
    total: 0,
    page: 1,
    pages: 1,
    isLoading: false
};

const rawMaterialSlice = createSlice({
    name: "rawMaterial",
    initialState,
    reducers: {
        setRawMaterials: (state, action) => {
            state.rawMaterials = action.payload.data;
            state.total = action.payload.total;
            state.page = action.payload.page;
            state.pages = action.payload.pages;
        },
        addRawMaterial: (state, action) => {
            state.rawMaterials.unshift(action.payload);
        },
        updateRawMaterial: (state, action) => {
            const index = state.rawMaterials.findIndex(
                (item) => item._id === action.payload._id
            );
            if (index !== -1) {
                state.rawMaterials[index] = action.payload;
            }
        },
        deleteRawMaterial: (state, action) => {
            state.rawMaterials = state.rawMaterials.filter(
                (item) => item._id !== action.payload
            );
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const {
    setRawMaterials,
    addRawMaterial,
    updateRawMaterial,
    deleteRawMaterial,
    setLoading
} = rawMaterialSlice.actions;

export const RawMaterialReducer = rawMaterialSlice.reducer;
